/**
 * @Description: 产品
 * @author: Xiao'Hong
 * @date: 2021/2/22
 * @fileName: product
 */
export default [
    {path: "/product", component: () => import('@/views/product/product.vue')},
]
